// react
import React, { useEffect, useContext} from 'react';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';
import CsvDownloader from 'react-csv-downloader';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { formateDate, transformValueFloattoFormated } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatorioDividasClinicasFechadas() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const { register, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
   
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
            show:true,
            color:color,
            message:message
        });
        setTimeout(function() {
            setNotification({show:false});
        }, 6000);       
    };
    
    useEffect(() => {
        verifyAcess();
    }, []);

    const verifyAcess = () =>{
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();
        }
        else //Acessando tela pelo modulo Clinica   
        {
            listSelectEstabelecimentosSelected([{estabelecimentoId:session.estabelecimentoId}]);
            setshowSelectEstabelecimentos(false)
        }
    }

    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(true);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);
    const LoadEstabelecimentos = () =>{
        setloadingSelectEstabelecimentos(true);   
        let endPointE = "estabelecimentos/inativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPointE).then(result=>{      
            if(result.status !== 200)
            {                                     
                showNotification(t('error_message.could_not_load_establishments')+"!",'danger'); 
                setloadingSelectEstabelecimentos(false); 
                return false; 
            }     
            setlistSelectEstabelecimentos(result.data);  
            setloadingSelectEstabelecimentos(false); 
            return true;                
        });  
    }
    const handleEstabelecimentoChange = event => {
        let value = event
        let data = getValues()

        let lstsAdd = [];
        let lstSelect = [];
        value.map(item =>{
            lstsAdd.push(item.estabelecimentoId); 
            
            lstSelect.push({
                estabelecimentoId:item.estabelecimentoId
            });                   
        });
        setestabelecimentos(lstsAdd); 
        setlistSelectEstabelecimentosSelected(lstSelect);

    }
    const handleClickSelecionarTodosEstabelecimentos = () =>{
        
        let data = getValues()
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item =>{
            lstsAdd.push(item.estabelecimentoId); 
            
            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });                   
        });
        setestabelecimentos(lstsAdd); 
        setlistSelectEstabelecimentosSelected(lstSelect);
    }
    
    const handleClickPesquisa = () =>{
        let data = getValues();
        
        if (listSelectEstabelecimentosSelected.length === 0)
            return setError(t('label.establishments'), "required")
        else
            clearError(t('label.establishments'))
        
        loadDados(listSelectEstabelecimentosSelected);
    };

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadDados = (obj) =>{ 
        setisLoadingList(true);       
        const endPoint = "relatorios/reldividasclinicasfechadas/";
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }
            
            setlist(result.data);
            loadDataCsv(result.data);
            setisLoadingList(false);
            return true;                
        });  
    }

    const columnsProp = [{
        Header: t('label.establishment'),
        filterable: false,
        accessor: "estabelecimento.descricao",
    },
    {
        Header: t('reports.debt_date'),
        filterable: false,
        accessor: "dataCadastro",
        Cell : (props)=>{
            const custom_date =  formateDate(props.value);
            return <span>{custom_date}</span>
        }
    },
    {
        Header: t('label.description'),
        filterable: false,
        accessor: "historico"
    },
    {
        Header: t('label.value'),
        filterable: false,
        accessor: "valor",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div>
    }]
    const columns = [...columnsProp]

    
    const [dataCSV,setdataCSV] = React.useState([]);  
    const columnsCSV = [
        {id: 'estabelecimento', displayName: 'Estabelecimento'}, 
        {id: 'dataCadastro', displayName: 'DT Divida'}, 
        {id: 'historico', displayName: 'Descrição'}, 
        {id: 'valor', displayName: 'Valor'}
    ];
    const loadDataCsv = (data) =>{
        let dtCsv = [];

        data.map(item =>{
            var obj = {
                estabelecimento: item.estabelecimento.descricao,
                dataCadastro: item.dataCadastro,
                historico: item.historico.trimEnd(),
                valor: item.valor
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
        console.log(dtCsv)
    } 

    const classes = useStyles();
    return (
    <div>
        <GridContainer>
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <Assignment />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>{t('reports.closed_clinic_debt_report')} </h4>
                    </CardHeader>
                    <CardBody>
                    <GridContainer>
                        {showSelectEstabelecimentos &&
                        <GridItem xs={12} sm={12} md={10}>
                            <FormControl fullWidth className={classes.formControl}>
                                <label className={errors.estabelecimentos?"select__label select__label_error":"select__label"}>
                                {t('label.establishment')} </label>
                                <Select
                                    classNamePrefix="select"  
                                    isSearchable={true}
                                    styles={ValidSelect(errors.estabelecimentos?true:false)} 
                                    placeholder={t('label.select')+"..."}
                                    isMulti={true}    
                                    name="estabelecimentos"                                  
                                    isLoading={loadingSelectEstabelecimentos}
                                    options={listSelectEstabelecimentos}     
                                    getOptionLabel={({descricao}) => descricao}
                                    getOptionValue={({estabelecimentoId}) => estabelecimentoId} 
                                    value={listSelectEstabelecimentos.filter(({estabelecimentoId}) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                    onChange={(value) => handleEstabelecimentoChange(value || [])}                                      
                                    ref={() => register( { name: "estabelecimentos" }) }
                                />
                                {errors.estabelecimentos &&
                                <FormHelperText>
                                    <span className="obg"> {t('label.select_an_establishment')} </span>
                                </FormHelperText>}
                            
                                <div style={{textAlign:'right',marginTop:'3px'}}>
                                <a href="#"  onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{marginTop:'10px'}}>
                                {t('label.select_all_establishments')}
                                </a></div>
                            </FormControl> 
                        </GridItem>}
                        <GridItem xs={12} sm={6} md={2}>
                            <Button  round color="primary" 
                                onClick={e => { handleClickPesquisa()}}>
                                {t('label.search')} 
                            </Button>
                        </GridItem>
                        {notification.show &&
                        <div>
                            <br/>
                            <SnackbarContent
                                message={notification.message}
                                color={notification.color}
                                closeNotification={() => setNotification({show:false})}
                                close
                            />
                        </div>}
                    </GridContainer>
                
                    {dataCSV.length > 0 &&
                        <div>
                            <div style={{float:'right'}}>
                            <CsvDownloader
                            filename="report"
                            columns={columnsCSV}
                            datas={dataCSV}
                            separator={";"}>
                                <Button  round color="default" size="sm" >CSV</Button> 
                            </CsvDownloader>
                            </div><div style={{clear:'both'}}></div>
                        </div>
                    }
                    <ReactTable
                        loading = {isLoadingList}
                        data={list}
                        filterable
                        defaultFilterMethod = {noCaseSensitive}
                        columns={columns}
                        //defaultPageSize={10}
                        showPagination={false}
                        pageSize={list.length}
                        minRows={5}
                        className="-striped -highlight"
                        previousText={t('button.previous')}
                        nextText={t('button.next')}
                        loadingText={t('label.loading')+"..."}
                        noDataText={t('information_message.no_records_found')+"!"}
                        pageText={t('label.page')}
                        ofText={t('label.of')}
                        rowsText={t('label.rows')}
                    />
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    </div>
    );
}